module.exports = __webpack_public_path__ + "img/fayi_01.1b0bd5ab.jpg";